import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { DatePicker } from 'material-ui-pickers';

import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { AddButton, DeleteButton } from 'components/core';
import { Section } from '../../ContentEdit';
import { BusinessLogo } from '../../../Logo';
import { ClientDialog } from 'components/admin/Dialogs';

import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

import { startEditBid } from '../../../../store/actions/bids';
import {
  startEditInvoice,
  startRemoveInvoiceField
} from '../../../../store/actions/invoices';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifycontent: 'space-between',

  },
  content: {
    flexGrow: 1,
    marginTop: theme.spacing.unit*3,
    marginLeft: theme.spacing.unit*3,
  },
  side: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  date: {
    flexGrow: 1,
  },
  client: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing.unit*2,
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  address: {
    marginTop: theme.spacing.unit*2,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  left: {
    width: '70px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  right: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexGrow: 1,
  },
  clientSelect: {
    width: '200px',
  },
});

class GeneralInfo extends Component {
  constructor(props){
    super(props);
    this.state = { showAddClient: false };
  }

  render() {
    const {
      classes,
      heading,
      invoice,
      help,
      invoiceValidation,
      showValidation,
      preview,
      clients,
      clientProjects,
      startEditInvoice,
      startEditBidEditorState,
      startRemoveInvoiceField
    } = this.props;
    const { showAddClient } = this.state;

    return(
      <div>
        <ClientDialog
          show={showAddClient}
          handleCreated={(result) => {
            startEditInvoice(invoice.id, { clientId: result });
          }}
          handleClose={() => this.setState({ showAddClient: false })}
        />
        <Section
          preview={preview}
          title="General Information"
          showContent={true}
          showAdd={false}>
          <div className={classes.root} >
            <div className={classes.content}>
              <BusinessLogo title="Landscaping done right" />
            </div>
            <div className={classes.side}>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <Typography variant="display3">
                    {heading}
                  </Typography>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <Typography variant="subheading">Ref #:</Typography>
                  <Typography variant="subheading">{invoice.invoiceNumber}</Typography>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <DatePicker
                      disabled={preview}
                      className={classes.date}
                      label="Date"
                      format="MMMM Do YYYY"
                      value={invoice.invoiceDate}
                      leftArrowIcon={<ArrowBackIcon />}
                      rightArrowIcon={<ArrowForwardIcon />}
                      onFocus={() => startEditBidEditorState("iGeneralDate")}
                      onChange={(date) => startEditInvoice(invoice.id, {invoiceDate: date.toDate().getTime()})}
                    />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left} />
                <div className={classes.right}>
                  <DatePicker
                      disabled={preview}
                      className={classes.date}
                      label="Due"
                      format="MMMM Do YYYY"
                      value={invoice.dueDate}
                      leftArrowIcon={<ArrowBackIcon />}
                      rightArrowIcon={<ArrowForwardIcon />}
                      onFocus={() => startEditBidEditorState("iGeneralDue")}
                      onChange={(date) => startEditInvoice(invoice.id, {dueDate: date.toDate().getTime()})}
                    />
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left}>
                  <Tooltip type={TooltipTypes.INVOICE_ADD_CLIENT} placement="left">
                    <AddButton
                      elevate={help.isCurrentStep(TooltipTypes.INVOICE_ADD_CLIENT)}
                      onClick={() => {
                        helpDispatch(TooltipTypes.INVOICE_ADD_CLIENT);
                        this.setState({ showAddClient: true });
                      }}
                    />
                  </Tooltip>
                </div>
                <div className={classes.right}>
                  <Tooltip type={TooltipTypes.INVOICE_SELECT_CLIENT} placement="left">
                    <FormControl
                      error={ showValidation ? !!invoiceValidation.validateField("clientId") : false }
                      style={{margin: '0px'}}
                      className={classes.clientSelect}>
                      <InputLabel htmlFor="client-simple">Client</InputLabel>
                      <Select
                        disabled={preview}
                        value={invoice.clientId === undefined ? "" : invoice.clientId}
                        onFocus={() => startEditBidEditorState("iGeneralClient")}
                        onChange={(event) => {
                          startEditInvoice(
                            invoice.id,
                            {
                              [event.target.name]: event.target.value,
                              projectId: ""
                            }
                          );
                          helpDispatch();
                        }}
                        inputProps={{
                          name: 'clientId',
                          id: 'client-simple',
                        }}
                      >
                        {clients &&
                          clients.map((client, i) => {
                            return <MenuItem key={i} value={client.id}>{client.fullName}</MenuItem>
                          })
                        }
                      </Select>
                      {showValidation && invoiceValidation.validateField("clientId") &&
                        <FormHelperText>{invoiceValidation.validateField("clientId")}</FormHelperText>
                      }
                    </FormControl>
                  </Tooltip>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.left}>
                  <DeleteButton
                    onClick={() => startRemoveInvoiceField(invoice.id, "projectId")}
                  />
                </div>
                <div className={classes.right}>
                  {clientProjects &&
                    <Tooltip type={TooltipTypes.INVOICE_JOB_OPTIONAL} placement="left">
                      <FormControl
                        style={{margin: '0px'}}
                        className={classes.clientSelect}
                      >
                        <InputLabel htmlFor="job-simple">Job (optional)</InputLabel>
                        <Select
                          value={invoice.projectId === undefined ? "" : invoice.projectId}
                          onFocus={() => startEditBidEditorState("iGeneralJob")}
                          onChange={(event) => {
                            startEditInvoice(invoice.id, { projectId: event.target.value });
                          }}
                          inputProps={{
                            name: 'jobId',
                            id: 'job-simple',
                          }}
                        >
                          {
                            clientProjects.map((project, i) => {
                              return <MenuItem key={i} value={project.id}>{project.jobCode}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Tooltip>
                  }
                </div>
              </div>
            </div>
          </div>
        </Section>
      </div>

    );
  }
}

GeneralInfo.defaultProps = {
  invoice: {
    template: {}
  }
};

const mapStateToProps = (state) => {
  const { id: invoiceId, showValidation } = state.adminState.invoice;
  const invoice = state.invoicesState.find(invoice => invoice.id === invoiceId);
  const clients = state.clientsState;
  const client = invoice.clientId === undefined
    ? undefined
    : clients.find((client) => client.id === invoice.clientId);
  const clientProjects = client && state.projectsState.filter(project => client.id === project.clientId);
  const invoiceValidation = state.validation.invoices.find(item => item.id === invoiceId);

  return {
    invoice: invoice,
    clients: clients,
    client: client,
    clientProjects,
    invoiceValidation,
    showValidation,
    help: state.help,
  }
};


const mapDispatchToProps = {
  startEditInvoice,
  startEditBid,
  startEditBidEditorState,
  startRemoveInvoiceField
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(GeneralInfo);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/Detail/GeneralInfo.jsx